<template>
  <div class="upload-files">
    <div id="divHabilitSelectors" class="input-file-container">
      <h4
        :for="'upload-file-' + name + horseId"
        :id="'upload-file-' + name + horseId"
        class="upload-files"
      >
        {{ text | trans }}
      </h4>
      <h5 class="font-regular" v-if="secondText">
        {{ secondText | trans }}
      </h5>
      <input
        class="input-file"
        :id="'fileupload-' + name + horseId"
        :name="name + '[]'"
        type="file"
        @change="fileChosen"
        multiple
      />
      <label
        :for="'fileupload-' + name + horseId"
        class="input-file-trigger"
        tabindex="0"
      >
        <template v-if="chosenFiles !== '' ">
          {{ chosenFiles }}
        </template>
        <template v-else>
          {{ 'javascript.horse_registration.upload_file' | trans }}
        </template>
      </label>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'FileUpload',
        props: {
          name: {
            type: String,
            require: true
          },
          text: {
            type: String,
            require: true
          },
          secondText: {
            type: String,
            require: false
          },
          horseId: {
            type: Number,
            require: true
          }
        },
      data() {
          return {
            chosenFiles: ''
          }
      },
      methods: {
        fileChosen(e) {
          const files = e.target.files
          for (const f of files) {
            this.chosenFiles += 'C:\\fakepath\\' + f.name + ','
          }
        }
      }
    };
</script>
